// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".demo-page{padding:16px}.demo-page h1{font-size:24px;margin:16px 0}", "",{"version":3,"sources":["webpack://./app/pages/debug/ListingDemoPage.scss"],"names":[],"mappings":"AAAA,WACE,YAAA,CAEA,cACE,cAAA,CACA,aAAA","sourcesContent":[".demo-page {\n  padding: 16px;\n\n  h1 {\n    font-size: 24px;\n    margin: 16px 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
